import { ColorPalette } from './types';

export const INITIAL_MARKDOWN = `- **Core Concepts**
  - Visualization
  - Organization
  - Creativity
- **Features**
  - AI Powered
    - Expansion
    - Explanation
  - Interactive
    - Drag & Drop
    - Editable Text
  - Customizable
    - Themes
    - Layouts
- **Technologies**
  - React
  - D3.js
  - Tailwind CSS
  - Google Gemini
- **Benefits**
  - Clarity
  - Efficiency
  - Memory Retention

<!-- MINDMAP_CONFIG
{
  "themeName": "Midnight",
  "meta": {
    "0": {
      "description": "Pillars of visual thinking."
    },
    "1-0": {
      "description": "Smart expansion via Gemini 2.0."
    },
    "2-3": {
      "description": "LLM powering app intelligence."
    }
  }
}
-->`;

export const PALETTES: ColorPalette[] = [
  {
    name: "Midnight",
    type: 'dark',
    background: "#0f172a", // slate-900
    nodeBackground: "#1e293b", // slate-800
    text: "#f8fafc", // slate-50
    lines: "#475569", // slate-600
    // Neon/Bright colors that pop on dark
    colors: ["#818cf8", "#34d399", "#f472b6", "#fbbf24", "#f87171", "#22d3ee"]
  },
  {
    name: "Cyberpunk",
    type: 'dark',
    background: "#050505", // Almost black
    nodeBackground: "#18181b", // zinc-900
    text: "#e4e4e7", // zinc-200
    lines: "#27272a", // zinc-800
    // High contrast neon: Fuchsia, Cyan, Yellow, Orange, Rose, Green
    colors: ["#d946ef", "#22d3ee", "#facc15", "#f97316", "#f43f5e", "#4ade80"]
  },
  {
    name: "Deep Space",
    type: 'dark',
    background: "#020617", // slate-950
    nodeBackground: "#0f172a", // slate-900
    text: "#f1f5f9", // slate-100
    lines: "#1e293b", // slate-800
    // Cool, starry colors: Sky, Lime, Purple, Amber, Rose, Teal
    colors: ["#38bdf8", "#a3e635", "#c084fc", "#fcd34d", "#fb7185", "#2dd4bf"]
  },
  {
    name: "Vampire",
    type: 'dark',
    background: "#282a36", // Dracula bg
    nodeBackground: "#44475a",
    text: "#f8f8f2",
    lines: "#6272a4",
    // Classic Dracula palette: Pink, Purple, Cyan, Green, Orange, Red
    colors: ["#ff79c6", "#bd93f9", "#8be9fd", "#50fa7b", "#ffb86c", "#ff5555"]
  },
  {
    name: "Dynamic",
    type: 'dark',
    background: "#171717", // Neutral 900
    nodeBackground: "#262626", // Neutral 800
    text: "#ffffff", // White
    lines: "#525252", // Neutral 600
    // Default fallback colors if no keyword match
    colors: ["#a3a3a3", "#737373", "#d4d4d4", "#525252", "#e5e5e5", "#404040"]
  },
  {
    name: "Ronin",
    type: 'dark',
    background: "#0a0a0a", // Neutral Black
    nodeBackground: "#171717", // Neutral 900
    text: "#fafafa", // Neutral 50
    lines: "#404040", // Neutral 700
    // Traditional: Vermilion, Indigo, Gold, Pine, Wisteria, Iron
    colors: ["#dc2626", "#4f46e5", "#d97706", "#059669", "#9333ea", "#94a3b8"]
  },
  {
    name: "Yozakura",
    type: 'dark',
    background: "#190818", // Dark Plum
    nodeBackground: "#361233",
    text: "#fdf2f8", // Pink 50
    lines: "#701a75", // Pink 900
    // Night Cherry Blossom: Pink, Magenta, Purple, Teal, Yellow, Orange
    colors: ["#f472b6", "#d946ef", "#8b5cf6", "#2dd4bf", "#facc15", "#fdba74"]
  },
  {
    name: "Zen Dark",
    type: 'dark',
    background: "#0c130d", // Dark Moss
    nodeBackground: "#1a2e1f",
    text: "#ecfccb", // Lime 100
    lines: "#14532d", // Green 900
    // Matcha, Bamboo, Stone, Earth, Water, Azuki
    colors: ["#84cc16", "#10b981", "#78716c", "#d97706", "#0ea5e9", "#be123c"]
  },
  {
    name: "Vibrant",
    type: 'light',
    background: "#f8fafc", // slate-50
    nodeBackground: "#ffffff",
    text: "#334155", // slate-700
    lines: "#cbd5e1", // slate-300
    // Red, Orange, Amber, Emerald, Blue, Purple
    colors: ["#ef4444", "#f97316", "#f59e0b", "#10b981", "#3b82f6", "#8b5cf6"]
  },
  {
    name: "Oceanic",
    type: 'light',
    background: "#f0f9ff", // sky-50
    nodeBackground: "#ffffff",
    text: "#0c4a6e", // sky-900
    lines: "#bae6fd", // sky-200
    // Distinct Blues, Teals, Indigos, Emeralds, Purples
    colors: ["#0ea5e9", "#14b8a6", "#3b82f6", "#8b5cf6", "#10b981", "#6366f1"]
  },
  {
    name: "Forest",
    type: 'light',
    background: "#f0fdf4", // green-50
    nodeBackground: "#ffffff",
    text: "#14532d", // green-900
    lines: "#bbf7d0", // green-200
    // Earthy tones: Greens, Browns, Moss, Orange, Yellow
    colors: ["#16a34a", "#ca8a04", "#0f766e", "#ea580c", "#65a30d", "#4d7c0f"]
  },
  {
    name: "Sunset",
    type: 'light',
    background: "#fff7ed", // orange-50
    nodeBackground: "#ffffff",
    text: "#7c2d12", // orange-900
    lines: "#fed7aa", // orange-200
    // Warm tones: Orange, Pink, Amber, Rose, Yellow, Purple
    colors: ["#ea580c", "#db2777", "#f59e0b", "#e11d48", "#facc15", "#9333ea"]
  }
];